/**
 * @generated SignedSource<<af4636a2c714ed1012ed38f8259df7cf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type CampaignPrType = "product_offer" | "rewarded";
export type ParentMediaType = "cast" | "instagram" | "other" | "tiktok" | "tiktok_go" | "twitter" | "youtube";
import { FragmentRefs } from "relay-runtime";
export type CampaignHorizonCampaign$data = {
  readonly banners: ReadonlyArray<{
    readonly file: string | null;
  }>;
  readonly gifting: boolean;
  readonly id: string;
  readonly mCategory: {
    readonly name: string;
  };
  readonly parentMediaType: ParentMediaType;
  readonly prType: CampaignPrType | null;
  readonly socialNetwork: {
    readonly recruitmentEndOn: any | null;
  };
  readonly title: string | null;
  readonly " $fragmentType": "CampaignHorizonCampaign";
};
export type CampaignHorizonCampaign$key = {
  readonly " $data"?: CampaignHorizonCampaign$data;
  readonly " $fragmentSpreads": FragmentRefs<"CampaignHorizonCampaign">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CampaignHorizonCampaign",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parentMediaType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gifting",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "prType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Banner",
      "kind": "LinkedField",
      "name": "banners",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "file",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MCategory",
      "kind": "LinkedField",
      "name": "mCategory",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SocialNetwork",
      "kind": "LinkedField",
      "name": "socialNetwork",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "recruitmentEndOn",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Campaign",
  "abstractKey": null
};

(node as any).hash = "4607b77b3977fed54c57ebbaf88c8d81";

export default node;
